<template>
  <div class="spangle-notice">
    <div class="spangle-notice__bulb-icon-wrapper">
      <UseSvg icon="bulb" class="spangle-notice__bulb-icon" />
    </div>
    <div class="spangle-notice__notice-wrapper">
      Upload bold designs with clear colors.
      <br class="spangle-notice__br" />
      <a href="#image-upload-tips" @click.stop>View Full Instructions</a>
    </div>
  </div>
</template>

<script>
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "SpangleNotice",
  components: { UseSvg }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.spangle-notice {
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-bottom: 12px;

  @include with-desktop {
    margin-bottom: 16px;
  }

  &__br {
    display: block;

    @include with-desktop {
      display: none;
    }
  }

  &__notice-wrapper {
    text-align: left;
  }

  &__bulb-icon-wrapper {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  &__bulb-icon {
    width: 24px;
    height: 24px;
    color: $white;
    background-color: $bulb-background;
    border-radius: 50%;
    padding: 2px;
  }
}
</style>
